export const SPOTIFY_SCOPES = [
  "user-read-email",
  "user-read-recently-played",
  "user-top-read",
  "user-library-read",
  "user-library-modify",
  "playlist-modify-public",
];
